import { WIND_SPEED_INTERVALS, dirsForVtype } from '../../../constants/windrose'

function fmtPct(value) {
  if (value == null) return '—'
  return value.toFixed(1)
}

const cellBorder = 'border-b border-r border-gray-200 last:border-r-0'
const thBase = `${cellBorder} px-2 py-1 text-xs font-normal text-center bg-gray-50 whitespace-nowrap`

// Směry ve sloupcích + poslední sloupec Bezvětří, rychlostní intervaly v řádcích
// (CALM sloupec zde prázdný), poslední řádek Suma (CALM sloupec vyplněn).
// Klient čte jen id z API, jméno směru/popisek intervalu bere z vlastních konstant
// (viz doc/plans/windrose-report.md sekce 3). Styl mřížky dle MinGrid.jsx.
export function WindRoseTable({ data, vtype }) {
  if (!data) return null

  const dirNames = dirsForVtype(vtype)
  const windDirs = dirNames.length

  // value podle pozice v poli (index 0..windDirs-1), API vrací seřazeno podle id
  function valuesByIndex(directions) {
    const arr = new Array(windDirs).fill(null)
    for (const d of directions || []) {
      const idx = Number(d.id) - 1
      if (idx >= 0 && idx < windDirs) arr[idx] = d.value
    }
    return arr
  }

  const sumValues = valuesByIndex(data.directions)
  const intervalRows = (data.intervals || []).map(iv => ({
    key: iv.interval,
    label: WIND_SPEED_INTERVALS[iv.interval] || iv.interval,
    values: valuesByIndex(iv.directions),
  }))

  return (
    <div className="shrink-0 overflow-hidden border border-gray-200">
      <div className="overflow-auto">
        <table className="border-separate border-spacing-0 border-l border-l-gray-400 border-r-2 border-r-gray-400 border-b-2 border-b-gray-400 text-xs">
          <thead>
            <tr>
              <th className={`${thBase} sticky left-0 z-10 font-semibold text-gray-600 border-t-2 border-t-gray-400 border-r-gray-400 text-left`}>
                Rychlost
              </th>
              {dirNames.map(name => (
                <th key={name} className={`${thBase} font-semibold text-gray-600 border-t-2 border-t-gray-400`}>
                  {name}
                </th>
              ))}
              <th className={`${thBase} font-semibold text-gray-600 border-t-2 border-t-gray-400 border-l border-l-gray-400`}>
                Bezvětří
              </th>
            </tr>
          </thead>

          <tbody>
            {intervalRows.map(row => (
              <tr key={row.key} className="group">
                <td className={`${cellBorder} group-last:border-b-0 sticky left-0 z-10 bg-gray-50 border-r-gray-400 px-2 py-0.5 text-gray-500 whitespace-nowrap`}>
                  {row.label}
                </td>
                {row.values.map((v, i) => (
                  <td
                    key={i}
                    className={`${cellBorder} group-last:border-b-0 px-1 py-0.5 text-right tabular-nums whitespace-nowrap bg-white ${v == null ? 'text-gray-300' : ''}`}
                  >
                    {fmtPct(v)}
                  </td>
                ))}
                <td className={`${cellBorder} group-last:border-b-0 px-1 py-0.5 text-right tabular-nums bg-white border-l border-l-gray-400 text-gray-300`}>
                  —
                </td>
              </tr>
            ))}
            <tr className="group">
              <td className={`${cellBorder} group-last:border-b-0 sticky left-0 z-10 bg-gray-50 border-r-gray-400 border-t-2 border-t-gray-400 px-2 py-0.5 text-gray-600 font-semibold whitespace-nowrap`}>
                Suma
              </td>
              {sumValues.map((v, i) => (
                <td
                  key={i}
                  className={`${cellBorder} group-last:border-b-0 border-t-2 border-t-gray-400 px-1 py-0.5 text-right tabular-nums whitespace-nowrap bg-white font-semibold ${v == null ? 'text-gray-300' : 'text-gray-700'}`}
                >
                  {fmtPct(v)}
                </td>
              ))}
              <td className={`${cellBorder} group-last:border-b-0 border-t-2 border-t-gray-400 border-l border-l-gray-400 px-1 py-0.5 text-right tabular-nums bg-white font-semibold text-gray-700`}>
                {fmtPct(data.calm)}
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  )
}
